import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { VUELTAS } from './types';

export const buscarVueltas = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/vueltas/listar`, body, config);
        await dispatch({ type: VUELTAS.BUSCAR, payload: res.data.vueltas });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const informacionVuelta = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/vueltas/informacion`, body, config);
        await dispatch({ type: VUELTAS.INFORMACION, payload: res.data.vuelta });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarVuelta = () => dispatch => {
    dispatch({ type: VUELTAS.LIMPIAR });
};
